import React, { useEffect } from 'react'
import { ControllerRenderProps, FieldValues } from 'react-hook-form'

import { MostBookedRegionType } from '../../../../organisms/location-picker/location-picker.type'
import { LocationPickerContentModal } from '../../../../organisms/location-picker/LocationPickerContentModal'
import { useLocationPicker } from '../../../../organisms/location-picker/useLocationPicker'

export type LocationPickerProps = {
  field: ControllerRenderProps<FieldValues, string>
  mostBookedRegions: MostBookedRegionType[]
  onValid: () => void
}

export const LocationPicker = ({
  field,
  mostBookedRegions,
  onValid,
}: LocationPickerProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null)
  const {
    onEditing,
    onSearchQuery,
    onInputChange,
    onLocationSelected,
    isEditing,
    isPlacePredictionsLoading,
    placePredictions,
    searchQueryIsEmpty,
    isLocationSelected,
    searchQuery,
  } = useLocationPicker({
    locationTypes: [
      'locality',
      'administrative_area_level_1',
      'administrative_area_level_2',
      'colloquial_area',
      'natural_feature',
    ],
  })

  useEffect(() => {
    onEditing(true)
    inputRef.current?.focus()
  }, [])

  return (
    <LocationPickerContentModal
      field={field}
      handlers={{
        onEditing,
        onSearchQuery,
        onInputChange,
        onLocationSelected,
        onValid,
      }}
      state={{
        isEditing,
        isPlacePredictionsLoading,
        placePredictions,
        searchQueryIsEmpty,
        isLocationSelected: isLocationSelected || !!field.value?.label,
        isMobile: true,
        revampPicker: true,
        shortLabel: false,
        mostBookedRegions,
        searchQuery,
      }}
      inputRef={inputRef}
    />
  )
}
